import { EyeSlashIcon } from "@heroicons/react/24/solid/index.js";

export function DisabledEyeIcon() {
  return (
    <div className={"bg-blue-100 text-primary p-4 rounded-2xl"}>
      <EyeSlashIcon className={"w-7 h-7"} />
    </div>
  );
}
